export default "__VITE_ASSET__D5BbHpWW__"